<template>
  <div class="humptext">
    <!-- 驼峰文本转换工具   -->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div v-if="this.globalVariable.tabs.length == 2">
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
        </div>
        <div v-else>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[2]
          }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div style="margin-top: 40px">
      <div>
        <el-input
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="inputValue"
          style="width: 45%; float: left"
        >
        </el-input>
        <div
          style="
            width: 40%;
            float: right;

            display: block;
            resize: vertical;
            padding: 5px 15px;
            line-height: 1.5;
            box-sizing: border-box;

            font-size: inherit;
            color: #606266;
            background-color: #fff;
            background-image: none;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
          "
        >
          <pre v-html="returnValue">{{returnValue}}</pre>
        </div>

        <br />
        <br />
        <el-button type="success" @click.native="hump()">文本转换</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { humpTextTrans } from "@/api/api";
export default {
  data() {
    return {
      //文本域输入值
      inputValue: "",
      returnValue: '',
    };
  },
  created () {
    this.globalVariable.setTabs(['常用工具','驼峰文本转换']);
  },
  methods: {
    hump() {
      humpTextTrans(this.inputValue).then((res) => {
        this.returnValue = res;
      });
    },
  },
};
</script>